import { render, staticRenderFns } from "./Page05.vue?vue&type=template&id=29435ae3&scoped=true&"
import script from "./Page05.vue?vue&type=script&lang=js&"
export * from "./Page05.vue?vue&type=script&lang=js&"
import style0 from "./Page05.vue?vue&type=style&index=0&id=29435ae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29435ae3",
  null
  
)

export default component.exports